import { BaseWhiteBoardService } from "../base";
import { EMIT_MAP } from "../constants";
import { getPenCursorBase64 } from "../pen-cursor";
class TIWboardService extends BaseWhiteBoardService {
  constructor(config) {
    super();
    this.config = config;
    this.client = null;
    this.initBoard();
    this.selectElementInfo = {};
    this.textSizeMap = {
      14: 280,
      16: 320,
      18: 360,
      20: 400,
    };
  }
  // 初始化白板
  initBoard() {
    const config = this.config;
    var initParams = {
      id: config.id, // dom节点id
      classId: config.classId, // 课堂 ID，32位整型，取值范围[1, 4294967294]
      sdkAppId: config.sdkAppId, // 整数
      userId: config.userId, // 字符串
      userSig: config.userSig, // 字符串
      config: {
        boardContentFitMode:
          window.TEduBoard.TEduBoardContentFitMode
            .TEDU_BOARD_FILE_FIT_MODE_CENTER_INSIDE, //自动调整白板宽高比与文件一致
      },
      styleConfig: {
        brushThin: 50,
        brushColor: "#000000",
        selectBoxColor: "#C9CDD4",
        selectAnchorColor: "#C9CDD4",
      },
      authConfig: {
        drawEnable: false,
        // systemCursorEnable: true, //影响激光笔显示
        isAutoHideRemoteCursor: true, // 远端画笔不动2秒后是否自动隐藏
        // mathGraphEnable: true,
        // formulaEnable: true,
      },
    };

    this.client = new window.TEduBoard(initParams);
    // this.client.setLogLevel(window.TEduBoard.TEduBoardLogLevel.ALL);
    this.registerListener();
    //启用点擦（分段擦除）功能
    if (this.client?.setPiecewiseErasureEnable) {
      this.client.setPiecewiseErasureEnable(true);
    }
    // 设置橡皮擦自定义图标
    this.client.setCursorIcon(
      window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_ERASER,
      {
        cursor: "url",
        url: "https://cdn.moguocdn.com/cdn/saas-web/live/images/eraser.png",
        offsetX: 16,
        offsetY: 16,
      }
    );

    // 设置画笔自定义图标
    this.client.setCursorIcon(
      window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_PEN,
      {
        cursor: "url",
        url: getPenCursorBase64("#000000"),
        offsetX: 2,
        offsetY: 10,
      }
    );

    // 设置激光笔自定义图标
    this.client.setCursorIcon(
      window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_LASER,
      {
        cursor: "url",
        url: "https://cdn.moguocdn.com/cdn/saas-web/live/images/laser.png?imageView2/0/w/33",
        offsetX: 16,
        offsetY: 16,
      }
    );

    //设置选框自定义图标
    this.client.setCursorIcon(
      window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_RECT_SELECT,
      {
        cursor: "url",
        url: "auto",
      }
    );

    // 设置文本自定义图标
    this.client.setCursorIcon(
      window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_TEXT,
      {
        cursor: "url",
        url: "https://cdn.moguocdn.com/cdn/saas-web/live/images/text.png?imageView2/0/w/30",
      }
    );

    // this.client.setRemoteCursorVisible(true);
  }

  registerListener() {
    // 1. 监听操作白板参数的数据，并将回调的数据通过 im 发送到接收者
    this.client.on(
      window.TEduBoard.EVENT.TEB_SYNCDATA,
      this.onDataSynced.bind(this)
    );
    // 监听白板错误事件
    this.client.on(window.TEduBoard.EVENT.TEB_ERROR, this.onError.bind(this));
    // 监听白板告警事件
    this.client.on(
      window.TEduBoard.EVENT.TEB_WARNING,
      this.onWarning.bind(this)
    );

    this.client.on(window.TEduBoard.EVENT.TEB_SNAPSHOT, ({ image }) => {
      console.timeEnd("shot");
      this.nextStep();
      // if (this.$store.state.snapShotCallBack) {
      //   window.teduBoard[this.$store.state.snapShotCallBack]();
      // }
      // this.$store.commit("setSnapShotCallBack", null);
      // this.$store.commit(
      //   "setBoardImages",
      //   this.updateArrayAtIndex(
      //     this.$store.state.boardImages,
      //     this.$store.state.shotPage,
      //     image
      //   )
      // );
      // this.$store.commit("setShotPage", null);
      // const downloadEl = document.createElement("a");
      // const event = new MouseEvent("click");
      // downloadEl.download = Date.now() + ".png";
      // downloadEl.href = image;
      // downloadEl.dispatchEvent(event);
    });

    // 监听选择元素事件
    this.client.on(window.TEduBoard.EVENT.TEB_SELECTED_ELEMENTS, (data) => {
      console.log("=====99选择元素 TEB_SELECTED_ELEMENTS data:", data);
      const userIds = [];
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.elementId) {
          const element = this.client.getElementById(item.elementId);
          console.log("===== TEB_SELECTED_ELEMENTS element:", element);
          if (element?.userId) {
            if (userIds.includes(element.userId)) {
              continue;
            } else if (userIds.length) {
              userIds.push(element.userId);
              break;
            } else {
              userIds.push(element.userId);
            }
          }
        }
      }
      if (userIds.length === 1) {
        this.selectElementInfo.userId = userIds[0];
        this.calcElementPosition(data);
      } else {
        this.selectElementInfo = {
          selectElements: data,
        };
        this._emit(EMIT_MAP.onShowToolbar, { res: this.selectElementInfo });
      }

      if (data.length) {
        // todo：其他方式
        setTimeout(() => {
          // 隐藏旋转元素
          this.hideRotateDiv();
        }, 10);
      }
    });

    // 监听元素位置更新事件
    this.client.on(
      window.TEduBoard.EVENT.TEB_BOARD_ELEMENT_POSITION_CHANGE,
      (data, status) => {
        if (this.selectElementInfo?.userId) {
          this.hideRotateDiv();
          this.calcElementPosition(data, status);
        }
      }
    );

    // 删除元素
    this.client.on(window.TEduBoard.EVENT.TEB_REMOVEELEMENT, (ids) => {
      this._emit(EMIT_MAP.onRemoveElement, ids);
    });

    // 白板可撤销状态改变
    this.client.on(
      window.TEduBoard.EVENT.TEB_OPERATE_CANUNDO_STATUS_CHANGED,
      (data) => {
        this._emit(EMIT_MAP.onCanUndoStatus, data);
      }
    );
    // 白板可恢复状态改变
    this.client.on(
      window.TEduBoard.EVENT.TEB_OPERATE_CANREDO_STATUS_CHANGED,
      (data) => {
        this._emit(EMIT_MAP.onCanRedoStatus, data);
      }
    );

    // 白板历史数据同步完成回调
    this.client.on(window.TEduBoard.EVENT.TEB_HISTROYDATA_SYNCCOMPLETED, () => {
      this._emit(EMIT_MAP.onReady);
    });

    // 切换文件回调
    this.client.on(window.TEduBoard.EVENT.TEB_SWITCHFILE, (fid) => {
      this._emit(EMIT_MAP.onTabSwitchFile, fid);
    });
    //  跳转白板页回调
    this.client.on(window.TEduBoard.EVENT.TEB_GOTOBOARD, (boardId, fid) => {
      this._emit(EMIT_MAP.onTabGotoBoard, fid);
    });

    // 缩放白板页回调
    this.client.on(window.TEduBoard.EVENT.TEB_ZOOM_DRAG_STATUS, () => {
      this._emit(EMIT_MAP.onScaleBoard);
    });
    this.client.on(
      window.TEduBoard.EVENT.TEB_CLASS_GROUP_STATUS_CHANGED,
      (data) => {
        console.log("live_white===TEB_CLASS_GROUP_STATUS_CHANGED", Date.now());
        console.log(
          "live_white===TEB_CLASS_GROUP_STATUS_CHANGED================",
          data
        );
        console.log(
          "live_white===TEB_CLASS_GROUP_STATUS_CHANGED---borderlist",
          this.client.getBoardList()
        );
        const groupInfo = this.client.getClassGroupInfoByGroupId("screenShare");
        console.log(
          "live_white===TEB_CLASS_GROUP_STATUS_CHANGED===groupInfo",
          groupInfo
        );
      }
    );
  }

  hideRotateDiv() {
    // 隐藏旋转元素
    const elements = document.querySelectorAll(".tiw-rotate-div");
    elements.forEach((element) => {
      const parent = element.parentElement;
      if (parent) {
        parent.style.display = "none";
      }
    });
  }

  calcElementPosition(data, status) {
    const boxArea = {
      minX: Infinity,
      minY: Infinity,
      maxX: -Infinity,
      maxY: -Infinity,
    };
    // 算最大选中元素区域
    data.forEach((element) => {
      boxArea.minX = Math.min(boxArea.minX, element.boundingbox.left);
      boxArea.maxX = Math.max(
        boxArea.maxX,
        element.boundingbox.left + element.boundingbox.width
      );
      boxArea.minY = Math.min(boxArea.minY, element.boundingbox.top);
      boxArea.maxY = Math.max(
        boxArea.maxY,
        element.boundingbox.top + element.boundingbox.height
      );
    });
    this.selectElementInfo.boxArea = boxArea;
    this.selectElementInfo.selectElements = data;
    this._emit(EMIT_MAP.onShowToolbar, {
      res: this.selectElementInfo,
      status,
    });
  }

  onDataSynced(data) {
    this._emit(EMIT_MAP.onDataSynced, data);
  }
  onError(code, msg) {
    console.log(
      "======================:  ",
      "TEB_ERROR",
      " errorCode:",
      code,
      " errorMessage:",
      msg
    );
    // DarkMessage({
    //   message: `白板出错啦，请刷新页面重试`,
    //   type: "error",
    // });
    this._emit(EMIT_MAP.onError, code, msg);
  }
  onWarning(code, msg) {
    this._emit(EMIT_MAP.onWarning, code, msg);
  }
  //白板同步数据
  addSyncData(data) {
    this.client.addSyncData(data);
  }
  prevBoard() {
    this.client.prevBoard();
  }
  nextBoard() {
    this.client.nextBoard();
  }
  switchFile(fileId, boardId, stepIndex) {
    return this.client.switchFile(fileId, boardId, stepIndex);
  }
  deleteFile(fileId) {
    return this.client.deleteFile(fileId);
  }
  setToolType(type) {
    const ToolTypeMap = {
      pen: window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_PEN,
      rect: window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_RECT,
      circle: window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_CIRCLE,
      triangle:
        window.TEduBoard.TEduBoardToolType
          .TEDU_BOARD_TOOL_TYPE_ISOSCELES_TRIANGLE,
      line: window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_LINE,
      text: window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_TEXT,
      eraser: window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_ERASER,
      laser: window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_LASER,
      select:
        window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_RECT_SELECT,
    };
    if (ToolTypeMap[type]) {
      if (type === "line") {
        this.client.setGraphStyle({
          lineType:
            window.TEduBoard.TEduBoardLineType.TEDU_BOARD_LINE_TYPE_SOLID,
          startArrowType:
            window.TEduBoard.TEduBoardArrowType.TEDU_BOARD_ARROW_TYPE_NONE,
          endArrowType:
            window.TEduBoard.TEduBoardArrowType.TEDU_BOARD_ARROW_TYPE_NONE,
        });
      }
      this.client.setToolType(ToolTypeMap[type]);
    } else if (type === "arrow") {
      this.client.setGraphStyle({
        lineType: window.TEduBoard.TEduBoardLineType.TEDU_BOARD_LINE_TYPE_SOLID,
        startArrowType:
          window.TEduBoard.TEduBoardArrowType.TEDU_BOARD_ARROW_TYPE_NONE,
        endArrowType:
          window.TEduBoard.TEduBoardArrowType.TEDU_BOARD_ARROW_TYPE_SOLID,
      });
      this.client.setToolType(
        window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_LINE
      );
    }
  }
  // 修改画笔样式
  setPenStyle(style) {
    const { size, color } = style;
    this.setToolType("pen");
    this.client.setBrushColor(color);
    this.client.setBrushThin(size);
    // 设置画笔自定义图标
    this.client.setCursorIcon(
      window.TEduBoard.TEduBoardToolType.TEDU_BOARD_TOOL_TYPE_PEN,
      {
        cursor: "url",
        url: getPenCursorBase64(color),
        offsetX: 2,
        offsetY: 10,
      }
    );
    // this.client.setSystemCursorEnable(true);
  }
  // 修改形状样式
  setShapeStyle(style) {
    const { shapeType, lineWidth, color } = style;
    this.setToolType(shapeType);
    this.client.setBrushColor(color);
    this.client.setBrushThin(lineWidth);
  }
  // 修改文本样式
  setTextStyle(style) {
    const { size, color } = style;
    const TextSizeMap = {
      14: 280,
      16: 320,
      18: 360,
      20: 400,
    };
    this.setToolType("text");
    this.client.setTextColor(color);
    this.client.setTextSize(TextSizeMap[size]);
  }
  // 设置鼠标
  setMouseTool() {
    this.setToolType("select");
  }
  // 设置橡皮檫
  setEraserTool() {
    this.setToolType("eraser");
  }
  // 设置激光笔
  setLaserTool() {
    this.setToolType("laser");
  }
  // 清空当前白板
  clear() {
    this.client.clear();
  }
  // 判断当前白板是否有内容
  isEmpty() {
    return !this.client.getBoardElementList()?.length;
  }
  // 销毁
  undo() {
    this.client.undo();
  }
  //恢复上一次撤销
  redo() {
    this.client.redo();
  }
  setBoardScale(scale) {
    this.client.setBoardScale(scale);
  }
  getBoardScale() {
    return this.client.getBoardScale();
  }

  getFileInfo(fid) {
    if (fid) {
      return this.client.getFileInfo(fid);
    } else {
      return this.client.getFileInfo(this.client.getCurrentFile());
    }
  }
  //增加一页白板
  addBoard() {
    return this.client.addBoard();
  }
  // 删除白板
  deleteBoard(boardId) {
    this.client.deleteBoard(boardId);
  }
  // 添加版本到分组
  addBoardToClassGroup(params) {
    const { boardId, groupId } = params;
    this.client.addBoardToClassGroup(groupId, boardId);
  }
  getAllClassGroupIds() {
    return this.client.getAllClassGroupIds();
  }
  setClassGroupEnable(enable) {
    this.client.setClassGroupEnable(enable);
  }
  setClassGroup(params) {
    const { groupId, boardIds, userIds, title, currentBoard } = params;
    this.client.setClassGroup(groupId, boardIds, userIds, title, currentBoard);
  }
  addUserToClassGroup(params) {
    const { groupId, userId } = params;
    this.client.addUserToClassGroup(groupId, userId);
  }
  getClassGroupIdByUserId(userId) {
    return this.client.getClassGroupIdByUserId(userId);
  }
  removeClassGroup(groupId) {
    this.client.removeClassGroup(groupId);
  }
  getBoardList() {
    return this.client.getBoardList();
  }
  getClassGroupInfoByGroupId(groupId) {
    return this.client.getClassGroupInfoByGroupId(groupId);
  }
  // 获取当前白板id
  getCurrentBoard() {
    return this.client.getCurrentBoard();
  }
  // 跳转白板
  gotoBoard(boardId) {
    this.client.gotoBoard(boardId);
  }
  // 删除元素
  removeElement(elements) {
    elements.forEach((item) => {
      this.client.updateElementById(item.elementId, {
        type: window.TEduBoard.TEduElementOperatorType.EL_DELETE,
        value: "",
      });
    });
  }

  // 获取白板全局背景
  getBoardBackground() {
    const { url } = this.client.getGlobalBackgroundPic();
    if (url) {
      return url;
    } else {
      return this.client.getGlobalBackgroundColor();
    }
  }
  // 设置白板全局背景
  setBoardBackground({ type, value }) {
    if (type === "image") {
      this.client.setGlobalBackgroundPic(
        value,
        window.TEduBoard.TEduBoardImageFitMode.TEDU_BOARD_IMAGE_FIT_MODE_CENTER
      );
      this.client.setGlobalBackgroundColor("rgba(255,255,255,1)");
    } else {
      this.client.setGlobalBackgroundPic("");
      this.client.setGlobalBackgroundColor(value);
    }
  }

  // 设置白板允许涂鸦
  setDrawEnable(enable) {
    this.client.setDrawEnable(enable);
    if (!enable) {
      // 设置回鼠标
      this.setMouseTool();
    } else {
      this.setToolType("pen");
    }
  }
  // 设置视频控制权限
  setVideoControlEnable(enable) {
    this.client.showVideoControl(enable);
  }

  //重新计算白板大小，并渲染
  resizeBoard() {
    this.client.resize();
  }
  isTextElement(selectedElement) {
    const textElementTypes = [
      window.TEduBoard.TEduBoardElementType.TEDU_BOARD_ELEMENT_TEXT,
      window.TEduBoard.TEduBoardElementType.TEDU_BOARD_ELEMENT_FORMULA,
    ];
    if (selectedElement) {
      return textElementTypes.includes(selectedElement.type);
    } else {
      return false;
    }
  }
  updateElementTextSize(element) {
    const value = this.textSizeMap[element.value];
    if (value) {
      this.client.updateElementById(element.elementId, {
        type: window.TEduBoard.TEduElementOperatorType.CHANGE_TEXT_SIZE,
        value: value,
      });
    }
  }
  updateElementTextColor(element) {
    this.client.updateElementById(element.elementId, {
      type: window.TEduBoard.TEduElementOperatorType.BOARDER_COLOR,
      value: element.value,
    });
  }
  getElementById(id) {
    return this.client.getElementById(id);
  }
  getTextColor() {
    return this.client.getTextColor();
  }
  getTextSize() {
    const size = this.client.getTextSize();
    let returnSize = 14;
    for (var key in this.textSizeMap) {
      if (this.textSizeMap[key] === size) {
        returnSize = key;
      }
    }
    return returnSize;
  }
  getBrushColor() {
    return this.client.getBrushColor();
  }
  // 获取画笔粗细
  getBrushThin() {
    return this.client.getBrushThin();
  }
  // 设置白板内容自适应模式
  setBoardContentFitMode() {
    // TEduBoard.TEduBoardContentFitMode.TEDU_BOARD_FILE_FIT_MODE_NONE
    // TEduBoard.TEduBoardContentFitMode.TEDU_BOARD_FILE_FIT_MODE_CENTER_INSIDE
    // TEduBoard.TEduBoardContentFitMode.TEDU_BOARD_FILE_FIT_MODE_CENTER_COVER
    return this.client.setBoardContentFitMode(
      window.TEduBoard.TEduBoardContentFitMode
        .TEDU_BOARD_FILE_FIT_MODE_CENTER_COVER
    );
  }
  //
  getBoardContentFitMode() {
    return this.client.getBoardContentFitMode();
  }
  // 设置当前白板宽高比例
  setBoardRatio(width, height) {
    this.client.setBoardRatio(`${width}:${height}`);
  }
  getBoardRatio() {
    return this.client.getBoardRatio();
  }
  setFullContainer() {
    const dom = document.querySelector("#" + this.config.id);
    if (dom) {
      const width = dom.offsetWidth || dom.clientWidth;
      const height = dom.offsetHeight || dom.clientHeight;
      this.setBoardRatio(width, height);
    }
  }
  addTranscodeFile(params = {}, needSwitch = true) {
    const fileId = this.client.addTranscodeFile(
      { resolution: "884x1122", pages: 1, ...params },
      needSwitch
    );
    return fileId;
  }
  getFileInfoList() {
    return this.client.getFileInfoList();
  }
  getCurrentFile() {
    return this.client.getCurrentFile();
  }
  isWhiteBoard(type) {
    return type === window.TEduBoard.TEduBoardFileType.WHITEBOARD;
  }
  addVideoFile(params = {}, needSwitch = true) {
    try {
      const { url, title } = params;
      const fileId = this.client.addVideoFile(url, title, needSwitch);
      return fileId;
    } catch (error) {
      console.error("addVideoFile", error);
      return null;
    }
  }
  addImagesFile(params = {}, needSwitch = true) {
    try {
      const { urls, title } = params;
      const fileId = this.client.addImagesFile(urls, title, needSwitch);
      return fileId;
    } catch (error) {
      console.error("addImagesFile", error);
      return null;
    }
  }
  destroy() {
    this.client.destroy();
  }
  // 静音视频 只有拥有控制权限的用户才能静音
  muteVideo(enable) {
    this.client.muteVideo(enable);
  }
}
export default TIWboardService;
